<script lang="ts">
    import type {RecordHolding} from 'typings/portaro.be.types';
    import type {DocumentDetailReactivePageData, DocumentDetailStaticPageData} from '../types';
    import {getInjector, getLocalization} from 'core/svelte-context/context';
    import {pipe} from 'core/utils';
    import {loc} from 'shared/utils/pipes';
    import {exists} from 'shared/utils/custom-utils';
    import {KpDocumentDetailPageService} from '../kp-document-detail-page.service';
    import {getPageContext} from 'shared/layouts/page-context';
    import {onDestroy} from 'svelte';
    import KpGenericPanel from 'shared/ui-widgets/panel/KpGenericPanel.svelte';
    import KpLoadingBlock from 'shared/components/kp-loading/KpLoadingBlock.svelte';
    import KpChipTag from 'shared/ui-widgets/chip/KpChipTag.svelte';

    const service = getInjector().getByClass(KpDocumentDetailPageService);
    const localize = getLocalization();
    const pageContext = getPageContext<DocumentDetailStaticPageData, DocumentDetailReactivePageData>();

    let recordHoldings: RecordHolding[] | undefined;
    const reactiveDataUnsubscribe = pageContext.reactiveData.subscribe((data) => recordHoldings = data.allRecordHoldings);
    onDestroy(reactiveDataUnsubscribe);
</script>

{#if service.isAdministrator}
    <section class="record-admin-info" aria-labelledby="record-admin-info-panel-label">
        <KpGenericPanel hasBodyPadding={false}>
            <svelte:fragment slot="heading">
                <h2 id="record-admin-info-panel-label" class="unset-style">
                    {localize(/* @kp-localization record.RecordUsages */ 'record.RecordUsages')}
                </h2>
            </svelte:fragment>

            {#if exists(recordHoldings)}
                <table class="table">
                    {#each recordHoldings as recordHolding(recordHolding.id)}
                        <tr>
                            <td class="td-full-width">{pipe(recordHolding.department, loc())}</td>
                            <td class="td-align-right">
                                {#if recordHolding.discarded}
                                    <KpChipTag chipSize="xs" chipStyle="danger-new">
                                        {localize(/* @kp-localization record.status.Discarded */ 'record.status.Discarded')}
                                    </KpChipTag>
                                {/if}

                                {#if recordHolding.deleted}
                                    <KpChipTag chipSize="xs" chipStyle="danger-new">
                                        {localize(/* @kp-localization record.status.Deleted */ 'record.status.Deleted')}
                                    </KpChipTag>
                                {/if}
                            </td>
                        </tr>
                    {/each}
                </table>
            {:else}
                <KpLoadingBlock size="sm"/>
            {/if}
        </KpGenericPanel>
    </section>
{/if}

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .table {
        margin-bottom: 0;

        tr > td {
            padding: @spacing-sm @spacing-ml !important;
            border-bottom: 1px solid @themed-border-default;
        }

        tr:last-child > td {
            border-bottom: none;
        }

        .td-full-width {
            width: 100%;
        }

        .td-align-right {
            text-align: right;
        }
    }
</style>